.radarContainer {
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .radarContainer {
    display: block;
  }
}
